import React, { useEffect, useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Select from 'react-select';
import ApiService from '../../services/apiService';
import { toast } from 'react-toastify';
import { setRows, addRow, removeRow, removeSingleRow, updateRow, clearRows } from '../../../Redux/actions/rowActions';
import { RxCross1 } from "react-icons/rx";
import AsyncSelect from 'react-select/async';

const UserStoreItems = ({ onRequisitionData, itemData, selectedLocation, formData, currencyPrecision }) => {
    const rows = useSelector(state => state.rows.rows);
    const dispatch = useDispatch();
    const [itemOptions, setItemOptions] = useState([]);
    const [itemRows, setItemRows] = useState([]);
    const [descriptionOptions, setDescriptionOptions] = useState([]);
    const [page, setPage] = useState(1);
    const [desPage, setDecPage] = useState(1);
    const apiService = new ApiService();
    const initialMount = useRef(true);
    const [rowsUpdated, setRowsUpdated] = useState(false);
    const [hasMore, setHasMore] = useState(true);
    const [loader, setLoader] = useState(false);

    useEffect(() => {

        if (selectedLocation && selectedLocation.label && rows[0].itemNo) {
            updateRowsWithNewStock();
            setRowsUpdated(true);
        }
    }, [selectedLocation]);
    useEffect(() => {
        const getItems = async () => {
            try {
                if (initialMount.current && itemData?.prDetails && itemData.prDetails.length > 0) {
                    const formattedRowsitm = itemData?.prDetails.map(async (detail, index) => {
                        const selecteditms = await apiService.getApiParamater("GET_ITEM", `?itemDescription=${detail.itemDescription}`);
                        let selecteditem = selecteditms?.data?.result[0]

                        return {
                            requisitionNo: detail.requisitionNo,
                            srno: detail.srno,
                            itemNo: detail.itemCode,
                            recordId: detail.itemCode,
                            itemDescription: detail.itemDescription,
                            branch: '',
                            qty: detail.qty,
                            uom: detail.uom,
                            // baseQty: selecteditem.convToInvUOM * detail.qty,
                            baseQty: 1 * detail.qty,
                            convRate: selecteditem.convToInvUOM,
                            baseAmount: detail.unitPrice,
                            specification: detail.specification,
                            amount: detail.amount,
                            stock: selecteditem.stock,
                            bol: '',
                            stockType: detail.stockType,
                            balQty: detail.balQty
                        };
                    }).filter(row => row !== null);
                    const formattedRows = await Promise.all(formattedRowsitm);
                    if (formattedRows.length > 0) {
                        dispatch(setRows(formattedRows));
                        onRequisitionData(formattedRows);
                    }
                }
            } catch (error) {
                console.error('Error fetching items:', error);
            }
        };
        if (itemData) {
            getItems();
        }
    }, [itemData, dispatch, onRequisitionData]);
    useEffect(() => {
        if (initialMount.current) {
            initialMount.current = false;
        } else {
            itemRows.forEach((row, index) => {
                dispatch(updateRow(index, row));
            });
        }
    }, [itemRows, dispatch]);

    useEffect(() => {
        onRequisitionData(rows);
    }, [rows]);

    useEffect(() => {
        fetchItemNo("", 1);
        fetchItemDesc("", 1);
    }, []);
    const fetchItemNo = async (inputValue = "", pageNumber = 1) => {
        if (loader) return;
        setLoader(true);
        try {
            const apiService = new ApiService();
            const params = new URLSearchParams();
            params.append('PageNo', pageNumber || 1);
            params.append('PageSize', 20);
            params.append('SearchTerm', inputValue || '');
            const response = await apiService.getApiParamater('GET_ITEM_DROPDOWN', `?${params.toString()}`);
            const fetchedItems = response.data.result.map(item => ({
                label: item.itemNo,
                value: item,
            }));
            if (fetchedItems.length < 20) setHasMore(false);
            setItemOptions(prevAccounts => [...prevAccounts, ...fetchedItems]);
            setLoader(false);
            return fetchedItems;
        } catch (error) {
            console.error("Error fetching account data:", error);
            setLoader(false);
            return [];
        }
    };
    const fetchItemDesc = async (inputValue = "", pageNumber = 1) => {
        if (loader) return;
        setLoader(true);
        try {
            const apiService = new ApiService();
            const params = new URLSearchParams();
            params.append('PageNo', pageNumber || 1);
            params.append('PageSize', 20);
            params.append('SearchTerm', inputValue || '');
            const response = await apiService.getApiParamater('GET_ITEM_DROPDOWN', `?${params.toString()}`);
            const fetchedItems = response.data.result.map(item => ({
                label: item.itemDescription,
                value: item,
            }));
            if (fetchedItems.length < 20) setHasMore(false);
            setDescriptionOptions(prevAccounts => [...prevAccounts, ...fetchedItems]);
            setLoader(false);
            return fetchedItems;
        } catch (error) {
            console.error("Error fetching account data:", error);
            setLoader(false);
            return [];
        }
    };
    const loadOptions = async (inputValue, callback) => {
        if (inputValue.trim().length < 3) {
            callback([]);
            return;
        }

        const options = await fetchItemNo(inputValue, 1);
        callback(options);
    };
    const loadDescOptions = async (inputValue, callback) => {
        if (inputValue.trim().length < 3) {
            callback([]);
            return;
        }

        const options = await fetchItemDesc(inputValue, 1);
        callback(options);
    };
    const loadMoreOptions = async (inputValue = "") => {
        if (inputValue.trim().length < 3 || !hasMore || loader) return;

        setPage(prevPage => prevPage + 1);
        await fetchItemNo(inputValue, page + 1);
    };
    const loadMoreDescOptions = async (inputValue = "") => {
        if (inputValue.trim().length < 3 || !hasMore || loader) return;

        setDecPage(prevPage => prevPage + 1);
        await fetchItemDesc(inputValue, desPage + 1);
    };
    const handleInputChange = async (index, fieldName, value) => {
        try {
            if (fieldName === 'qty' && value < 0) {
                toast.warning('Quantity cannot be less than 0.');
                return;
            }

            const isDuplicate = rows.some((row, rowIndex) => rowIndex !== index && (row.itemNo === value || row.itemDescription === value));
            if (isDuplicate) {
                toast.error('Please choose a different item.');
                return;
            }
            if (selectedLocation.length === 0) {
                toast.warning("Select Location");
                return;
            }
            const updatedRows = [...rows];
            const updatedRow = { ...updatedRows[index], [fieldName]: value, srno: ("0" + (index + 1)).slice(-2) };

            if (fieldName === 'itemNo' || fieldName === 'itemDescription') {
                const queryParam = fieldName === 'itemNo' ? `itemNo=${value}` : `ItemDescription=${value}`;
                const res = await apiService.getApiParamater('GET_ITEM_STORE', `?Warehouse=${selectedLocation.label}&${queryParam}`);

                let selecteditmstock = res?.data?.result?.[0]
                if (selecteditmstock) {
                    updatedRow.itemDescription = selecteditmstock.itemDescription;
                    updatedRow.requisitionNo = selecteditmstock.itemDescription;
                    updatedRow.uom = selecteditmstock.unitMeasurement;
                    updatedRow.itemNo = selecteditmstock.itemNo;
                    updatedRow.specification = selecteditmstock.specification;
                    updatedRow.baseQty = 0;
                    updatedRow.stock = selecteditmstock?.stock || 0;
                    updatedRow.stockType = selecteditmstock?.stockType;
                    updatedRow.supplierId = selecteditmstock?.supplier;
                    updatedRow.baseAmount = selecteditmstock?.avgPrice;
                }
            }

            if (fieldName === 'qty') {
                const quantity = parseFloat(value);
                const baseQty = 1; // Adjust this as necessary
                updatedRow.baseQty = (!isNaN(quantity) && quantity !== 0) ? (quantity * baseQty).toFixed(currencyPrecision || 0) : 0;
            }

            if (fieldName === 'qty' || fieldName === 'baseAmount') {
                const quantity = parseFloat(updatedRow.qty);
                const unitPrice = parseFloat(updatedRow.baseAmount);
                updatedRow.amount = (!isNaN(quantity) && !isNaN(unitPrice)) ? (unitPrice * quantity).toFixed(currencyPrecision || 0) : 0;
            }

            updatedRows[index] = updatedRow;
            dispatch(setRows(updatedRows));
            setItemRows(updatedRows);
            onRequisitionData(updatedRows);
        } catch (error) {
            console.error('Error handling input change:', error);
        }
    };
    const addNewRow = () => {
        const newRow = {
            srno: '',
            itemNo: '',
            requisitionNo: '',
            itemDescription: '',
            branch: '',
            qty: '',
            uom: '',
            baseQty: '',
            convRate: '',
            baseAmount: '',
            amount: '',
            stock: '',
            bol: '',
            recordId: '',
            specification: '',
            supplierId: '',
        };
        dispatch(addRow(newRow));
        const updatedRows = [...rows, newRow];
        setItemRows(updatedRows);
        onRequisitionData(updatedRows);
        dispatch(setRows(updatedRows));
    };
    const handleRemoveRow = (index) => {
        dispatch(removeSingleRow(index));
        const updatedRows = rows
            .filter((_, i) => i !== index)
            .map((row, i) => ({
                ...row,
                srno: i + 1
            }));
        onRequisitionData(updatedRows);
        setItemRows(updatedRows)
        dispatch(setRows(updatedRows));

    };
    const updateRowsWithNewStock = async () => {
        try {

            const updatedRows = rows.map(row => ({ ...row }));
            const apiPromises = updatedRows.map(async (row, index) => {
                const queryParam = `itemNo=${row.itemNo}`;
                const response = await apiService.getApiParamater(
                    'GET_ITEM_STORE',
                    `?Warehouse=${selectedLocation.label}&${queryParam}`
                );
                if (response?.data?.statusCode === 200) {

                    const itemData = response.data.result[0];
                    updatedRows[index].stock = itemData.stock || 0;
                    updatedRows[index].stockType = itemData.stockType || "---";
                    updatedRows[index].itemDescription = itemData.itemDescription;
                    updatedRows[index].uom = itemData.unitMeasurement;
                    // updatedRows[index].baseQty = parseFloat(itemData.convToInvUOM);
                } else if (response?.data?.statusCode === 204) {
                    updatedRows[index] = {
                        ...row,
                        stock: 0,
                    };
                }
            });
            await Promise.all(apiPromises);
            dispatch(setRows([...updatedRows]));
            onRequisitionData(updatedRows);
        } catch (error) {
            console.error('Error updating rows with new stock:', error);
        }
    }
    const preventNegativeSign = (e) => {
        if (e.key === "-") {
            e.preventDefault();
        }
    };
    return (
        <div className='table-container p-2 mb-5' style={{ overflowX: 'auto', height: "400px" }}>
            <table>
                <thead className='dynoTable'>
                    <tr>
                        <th></th>
                        <th>Sr no</th>
                        <th>Item No</th>
                        <th>Description</th>
                        <th>Item Specs</th>
                        <th>Qty</th>
                        <th>Inventory UOM</th>
                        <th>Inventory Qty</th>
                        <th>Stock</th>
                        <th>Stock Type</th>
                        <th>Delivery Date</th>
                    </tr>
                </thead>
                <tbody>
                    {Array.isArray(itemRows) && rows?.map((row, index) => (
                        <tr key={index}>
                            {itemData?.eye ?
                                <td className='m-0 p-0' style={{ border: "1px solid rgba(118, 118, 118, 0.3)", cursor: "not-allowed", suppressMovable: true, width: "50px" }}>
                                    <div className='center'><RxCross1 size={25} disabled /></div>
                                </td> :
                                <td className='m-0 p-0' style={{ border: "1px solid rgba(118, 118, 118, 0.3)", suppressMovable: true, width: "50px" }}>
                                    <div onClick={() => handleRemoveRow(index)} className='center'>
                                        <RxCross1 size={25} />
                                    </div>
                                </td>
                            }
                            <td className='m-0 p-0'><input className='p-2' type="text" style={{ width: "80px" }} value={row.srno} disabled /></td>
                            <td className='m-0 p-0'>
                                {itemData?.eye ?
                                    <input className='p-2' type='text' disabled value={row?.itemNo} />
                                    :
                                    <AsyncSelect
                                        cacheOptions
                                        value={{ value: row.itemNo, label: row.itemNo }}
                                        options={itemOptions}
                                        loadOptions={loadOptions}
                                        onChange={selectedOption => handleInputChange(index, 'itemNo', selectedOption.label)}
                                        className="w-100 p-0"
                                        defaultOptions={itemOptions}
                                        onMenuScrollToBottom={loadMoreOptions}
                                        noOptionsMessage={({ inputValue }) =>
                                            inputValue.length < 3
                                                ? "Type at least 3 characters..."
                                                : "No records found"
                                        }
                                    />
                                }
                            </td>
                            <td className='m-0 p-0'>
                                {itemData?.eye ?
                                    <input className='p-2' disabled value={row.itemDescription} />
                                    :
                                    <AsyncSelect
                                        cacheOptions
                                        value={{ value: row.itemDescription, label: row.itemDescription }}
                                        options={descriptionOptions}
                                        loadOptions={loadDescOptions}
                                        onChange={selectedOption => handleInputChange(index, 'itemDescription', selectedOption.label)}
                                        className="w-100 p-0"
                                        defaultOptions={descriptionOptions}
                                        onMenuScrollToBottom={loadMoreDescOptions}
                                        noOptionsMessage={({ inputValue }) =>
                                            inputValue.length < 3
                                                ? "Type at least 3 characters..."
                                                : "No records found"
                                        }
                                    />
                                }
                            </td>
                            {itemData?.eye ?
                                <td className='m-0 p-0'><input className='p-2' disabled value={row.specification} style={{ width: "150px" }} /></td>
                                :
                                <td className='m-0 p-0'><input className='p-2' style={{ width: "150px" }} type="text" value={row.specification} onChange={e => handleInputChange(index, 'specification', e.target.value)} /></td>
                            }
                            {itemData?.eye ?
                                <td className='m-0 p-0'><input className='p-2' disabled value={row.qty} style={{ width: "110px" }} /></td>
                                :
                                <td className='m-0 p-0'><input className='p-2' type="number" onWheel={(e) => e.target.blur()} onKeyDown={preventNegativeSign}
                                    value={row.qty} style={{ width: "110px" }} onChange={e => handleInputChange(index, 'qty', e.target.value)} /></td>
                            }
                            {itemData?.eye ?
                                <td className='m-0 p-0'><input className='p-2' disabled value={row.uom} style={{ width: "150px" }} /></td>
                                :
                                <td className='m-0 p-0'><input className='p-2' disabled type="text" value={row.uom} style={{ width: "150px" }} /></td>
                            }
                            {itemData?.eye ?
                                <td className='m-0 p-0'><input className='p-2' disabled value={row.baseQty} style={{ width: "150px" }} /></td>
                                :
                                <td className='m-0 p-0'><input className='p-2' disabled value={row.baseQty} style={{ width: "150px" }} /></td>
                            }
                            {itemData?.eye ?
                                <td className='m-0 p-0'><input className='p-2' disabled value={row.stock || 0} style={{ width: "140px" }} /></td>
                                :
                                <td className='m-0 p-0'><input className='p-2' disabled type="text" style={{ width: "140px" }} value={row.stock || 0} /></td>
                            }
                            {itemData?.eye ?
                                <td className='m-0 p-0'><input className='p-2' disabled value={row.stockType || "---"} style={{ width: "120px" }} /></td>
                                :
                                <td className='m-0 p-0'><input className='p-2' disabled type="text" value={row.stockType || "---"} style={{ width: "120px" }} /></td>
                            }
                            {itemData?.eye ?
                                <td className='m-0 p-0'><input className='p-2' disabled type="datetime-local" value={formData.deliveryDate} style={{ width: "150px" }} /></td>
                                :
                                <td className='m-0 p-0'><input className='p-2' disabled type="datetime-local" value={formData.deliveryDate} style={{ width: "150px" }} /></td>
                            }
                        </tr>
                    ))}
                </tbody>
            </table>
            {itemData?.eye ? "" :
                <div className='row mt-5'>
                    <div className='col-2'>
                        <button className='mainbtn ' onClick={addNewRow}>
                            Add Item
                        </button>
                    </div>
                    {/* <div className=' col-2'>
                        <button className='mainbtn ' onClick={removeLastRow}>
                            Remove
                        </button>
                    </div> */}
                </div>
            }
        </div>
    );
};

export default UserStoreItems;
